import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';


declare var fabric: any;

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent implements OnInit {

  modalNotifyLogout: any;

  constructor(private authService : AuthService){

  }

  ngOnInit(): void {
    const dialog = document.querySelector('.ms-Dialog-Notify');
    this.modalNotifyLogout = new fabric['Dialog'](dialog);

    this.modalNotifyLogout.open();
  }


  close(){
    this.modalNotifyLogout.close();
  }

  onLogOut(){
    this.authService.logout();
  }
}
